(function () {
  function setMain(gallery, btn) {
    const mainImg = gallery.querySelector('.maxi-main-img');
    const full = btn.dataset.full;
    if (!mainImg || !full) return;

    mainImg.src = full;
    const alt = btn.querySelector('img')?.alt;
    if (alt) mainImg.alt = alt;

    gallery.querySelectorAll('.maxi-thumb').forEach(t => t.classList.remove('is-active'));
    btn.classList.add('is-active');
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.maxi-thumb');
    if (!btn) return;
    const gallery = btn.closest('[data-maxi-gallery]');
    if (!gallery) return;
    setMain(gallery, btn);
  });

  // Dawn variant change (common event)
  document.addEventListener('variant:change', (e) => {
    const variant = e.detail?.variant;
    const mediaId = variant?.featured_media?.id;
    if (!mediaId) return;

    document.querySelectorAll('[data-maxi-gallery]').forEach((gallery) => {
      const btn = gallery.querySelector(`.maxi-thumb[data-media-id="${mediaId}"]`);
      if (btn) {
        setMain(gallery, btn);
        btn.scrollIntoView({ block: 'nearest' });
      }
    });
  });
})();